<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">
        <i class="el-icon-s-home"></i> 首页
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <i class="el-icon-bank-card"></i> 工行支付列表
      </el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);">
      <!-- 搜索区域 -->
      <div class="search-container" style="padding: 20px; background: #f8f9fa; border-radius: 8px; margin-bottom: 20px;">
        <div class="search-title" style="display: flex; align-items: center; margin-bottom: 20px;">
          <i class="el-icon-search" style="color: #409EFF; font-size: 18px; margin-right: 8px;"></i>
          <span style="font-size: 16px; font-weight: 500; color: #303133;">查询条件</span>
        </div>
        <el-form
                :inline="true"
                size="mini"
                :model="searchForm"
                ref="searchForRef"
                autocomplete="on"
        >
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="所属代理商" style="margin-bottom: 15px;">
                <el-input
                        placeholder="请选择所属代理商"
                        v-model="searchForm.proxy_name"
                        :readonly="true"
                        @click.native="cProxy"
                        clearable
                        style="width: 100%;"

                >
                  <template slot="prefix">
                    <i class="el-icon-user"></i>
                  </template>
                  <i slot="suffix" class="el-icon-more" style="cursor: pointer;"></i>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="商户编号" style="margin-bottom: 15px;">
                <el-input
                        v-model="searchForm.cusid"
                        placeholder="请输入商户编号"
                        clearable
                        style="width: 100%;"
                >
                  <template slot="prefix">
                    <i class="el-icon-document"></i>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="结算状态" style="margin-bottom: 15px;">
                <el-select
                        v-model="searchForm.is_deal"
                        placeholder="请选择结算状态"
                        clearable
                        style="width: 100%;"
                        size="small"
                >
                  <template slot="prefix">
                    <i class="el-icon-circle-check" style="color: #909399;"></i>
                  </template>
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已结算" value="1">
                    <span style="display: flex; align-items: center;">
                      <i class="el-icon-success" style="color: #67C23A; margin-right: 5px;"></i>
                      已结算
                    </span>
                  </el-option>
                  <el-option label="未结算" value="0">
                    <span style="display: flex; align-items: center;">
                      <i class="el-icon-warning" style="color: #E6A23C; margin-right: 5px;"></i>
                      未结算
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="支付月份" style="margin-bottom: 15px;">
                <el-date-picker
                        v-model="searchForm.pay_time"
                        type="month"
                        placeholder="请选择支付月份"
                        style="width: 100%;"
                        format="yyyy年MM月"
                        value-format="timestamp"
                        :picker-options="monthPickerOptions"
                >
                  <template slot="prefix">
                    <i class="el-icon-date"></i>
                  </template>
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="6" style="display: flex; align-items: flex-end; justify-content: flex-start;">
              <el-form-item style="margin-bottom: 15px;">
                <el-button
                        type="primary"
                        size="small"
                        @click="searchSubmit()"
                        style="width: 100px; margin-right: 10px;"
                >
                  <i class="el-icon-search"></i> 搜索
                </el-button>
                <el-button
                        type="default"
                        size="small"
                        @click="resetSearch()"
                        style="width: 100px;"
                        plain
                >
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 紧凑型统计信息卡片 -->
      <div class="compact-statistics" style="margin-bottom: 25px;">
        <el-row :gutter="16">
          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 12px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 90px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-money" style="font-size: 20px; color: #409EFF;"></i>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 3px;">
                ¥ {{ statistics.totalAmount }}
              </div>
              <div style="font-size: 12px; color: #909399;">总金额</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 12px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 90px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-document" style="font-size: 20px; color: #67C23A;"></i>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 3px;">
                {{ statistics.totalCount }}
              </div>
              <div style="font-size: 12px; color: #909399;">总条数</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 12px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 90px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-success" style="font-size: 20px; color: #E6A23C;"></i>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 3px;">
                ¥ {{ statistics.settledAmount }}
              </div>
              <div style="font-size: 12px; color: #909399;">已结算金额</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 12px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 90px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-check" style="font-size: 20px; color: #F56C6C;"></i>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 3px;">
                {{ statistics.settledCount }}
              </div>
              <div style="font-size: 12px; color: #909399;">已结算条数</div>
            </div>
          </el-col>

          <!-- 可以添加更多统计卡片 -->
          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 12px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 90px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-coin" style="font-size: 20px; color: #909399;"></i>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 3px;">
                ¥ {{ (parseFloat(statistics.totalAmount) - parseFloat(statistics.settledAmount)).toFixed(2) }}
              </div>
              <div style="font-size: 12px; color: #909399;">待结算金额</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 12px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 90px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-time" style="font-size: 20px; color: #909399;"></i>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 3px;">
                {{ statistics.totalCount - statistics.settledCount }}
              </div>
              <div style="font-size: 12px; color: #909399;">待结算条数</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 12px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 90px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-percentage" style="font-size: 20px; color: #409EFF;"></i>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 3px;">
                {{ statistics.totalCount > 0 ? ((statistics.settledCount / statistics.totalCount) * 100).toFixed(1) : '0.0' }}%
              </div>
              <div style="font-size: 12px; color: #909399;">结算完成率</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 12px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 90px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 5px;">
                <i class="el-icon-odometer" style="font-size: 20px; color: #67C23A;"></i>
              </div>
              <div style="font-size: 18px; font-weight: bold; color: #303133; margin-bottom: 3px;">
                ¥ {{ statistics.totalCount > 0 ? (parseFloat(statistics.totalAmount) / statistics.totalCount).toFixed(2) : '0.00' }}
              </div>
              <div style="font-size: 12px; color: #909399;">平均金额</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 表格区域 -->
      <div class="table-container" style="background: white; padding: 20px; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);">
        <div class="table-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <div style="display: flex; align-items: center;">
            <i class="el-icon-bank-card" style="color: #409EFF; font-size: 20px; margin-right: 8px;"></i>
            <span style="font-size: 16px; font-weight: 500; color: #303133;">工行支付列表</span>
            <el-tag type="info" size="small" style="margin-left: 10px;">ICBC</el-tag>
          </div>
          <div>
            <el-tag type="primary" size="small">共 {{ total }} 条记录</el-tag>
          </div>
        </div>

        <el-table
                ref="multipleTable"
                :data="tableLoadData"
                size="small"
                stripe
                border
                style="width: 100%; border-radius: 4px; overflow: hidden;"
                :header-row-style="{background: '#f5f7fa', color: '#909399', fontWeight: 'bold'}"
                :cell-style="{padding: '10px 0'}"
                :row-class-name="tableRowClassName"
        >
          <el-table-column
                  :index="indexMethod"
                  type="index"
                  label="序号"
                  width="70"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #909399; font-weight: 500;">{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="所属代理"
                  width="120"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.proxy" type="info" size="small" effect="plain">
                <i class="el-icon-user"></i> {{ scope.row.proxy.real_name }}
              </el-tag>
              <span v-else style="color: #C0C4CC; font-style: italic;">-</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="商户名称"
                  width="200"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #303133; font-weight: 500;">{{ scope.row.merchant_name || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="商户编号"
                  width="180"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <div style="color: #409EFF; font-weight: 500; font-family: monospace;">
                {{ scope.row.cusid }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
                  label="金额"
                  width="110"
                  align="right"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #E6A23C; font-weight: bold; font-size: 14px;">
                ¥ {{ scope.row.balance }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
                  label="月份"
                  width="110"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag type="warning" size="small">
                <i class="el-icon-date"></i> {{ scope.row.pay_time | monthFormat }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
                  label="创建时间"
                  width="180"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <div style="color: #606266;">
                <i class="el-icon-time" style="margin-right: 5px;"></i>
                {{ scope.row.create_time | timeFormat }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
                  label="结算状态"
                  width="120"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag
                      :type="getStatusType(scope.row)"
                      size="small"
                      effect="light"
                      style="font-weight: 500;"
              >
                <i :class="getStatusIcon(scope.row)" style="margin-right: 4px;"></i>
                {{ getStatusText(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>

<!--          <el-table-column-->
<!--                  label="操作"-->
<!--                  width="120"-->
<!--                  align="center"-->
<!--                  header-align="center"-->
<!--                  fixed="right"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <el-button-->
<!--                      v-if="scope.row.is_deal === 0"-->
<!--                      type="primary"-->
<!--                      size="mini"-->
<!--                      @click="handleSettle(scope.row)"-->
<!--                      style="padding: 4px 8px; font-size: 12px;"-->
<!--              >-->
<!--                <i class="el-icon-check"></i> 结算-->
<!--              </el-button>-->
<!--              <el-tag-->
<!--                      v-else-->
<!--                      type="success"-->
<!--                      size="small"-->
<!--                      effect="plain"-->
<!--              >-->
<!--                <i class="el-icon-success"></i> 已结算-->
<!--              </el-tag>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container" style="margin-top: 25px; display: flex; justify-content: space-between; align-items: center;">
          <div style="color: #606266; font-size: 14px;">
            显示第 {{ (pageNum - 1) * pageSize + 1 }} 到 {{ Math.min(pageNum * pageSize, total) }} 条记录，共 {{ total }} 条
          </div>
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 30, 100]"
                  :page-size="pageSize"
                  layout="sizes, prev, pager, next, jumper"
                  :total="total"
                  style="margin-top: 10px;"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 代理选择弹框 -->
    <eProxyList
            :formData="formData2"
            :visible.sync="visible2"
            :title="title2"
            v-on:eventChoose="chooseProxy"
            :closeForm="closeForm2"
    />
  </div>
</template>

<script>
  import eProxyList from "../common/eProxyList"
  import moment from 'moment'     //日期时间转换

  export default {
    name: "orderIcbcList",
    components: {
      eProxyList
    },
    props: {},
    data() {
      // 获取上个月的时间戳
      const lastMonth = moment().subtract(1, 'months').startOf('month').valueOf();

      return {
        // 月份选择器配置
        monthPickerOptions: {
          disabledDate(time) {
            // 可选限制：比如不能选择未来的月份
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: '本月',
            onClick(picker) {
              const start = moment().startOf('month').valueOf();
              picker.$emit('pick', start);
            }
          }, {
            text: '上个月',
            onClick(picker) {
              const start = moment().subtract(1, 'months').startOf('month').valueOf();
              picker.$emit('pick', start);
            }
          }, {
            text: '上上个月',
            onClick(picker) {
              const start = moment().subtract(2, 'months').startOf('month').valueOf();
              picker.$emit('pick', start);
            }
          }]
        },

        formData2:{},
        title2:'',
        visible2:false,

        formData: {},
        title: "",
        visible: false,

        title1: "",
        visible1: false,

        gradeList:[],
        // 搜索
        searchForm: {
          cusid: "",
          service_cusid: "",
          pay_time: lastMonth, // 初始化为上个月
          is_deal: "", // 结算状态
          proxy_name:'',
          proxy_id:'',
        },

        // 统计数据
        statistics: {
          totalAmount: '0.00',
          totalCount: 0,
          settledAmount: '0.00',
          settledCount: 0
        },

        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',
      };
    },
    created() {
      this.showType = this.$route.query.showType;
      this.DataList()
      this.departData()
    },
    filters: {
      //时间格式化
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD");
      },
      monthFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM");
      },
    },
    methods: {
      // 表格行样式
      tableRowClassName({row, rowIndex}) {
        console.log(row)
        if (rowIndex % 2 === 0) {
          return 'even-row';
        } else {
          return 'odd-row';
        }
      },

      // 获取状态标签类型
      getStatusType(row) {
        if (row.is_deal === 1) {
          return 'success';
        } else if (row.is_deal === 0) {
          return 'warning';
        } else {
          return 'info';
        }
      },

      // 获取状态图标
      getStatusIcon(row) {
        if (row.is_deal === 1) {
          return 'el-icon-success';
        } else if (row.is_deal === 0) {
          return 'el-icon-warning';
        } else {
          return 'el-icon-question';
        }
      },

      // 获取状态文本
      getStatusText(row) {
        if (row.is_deal === 1) {
          return '已结算';
        } else if (row.is_deal === 0) {
          return '待结算';
        } else {
          return '未知状态';
        }
      },

      // 处理结算操作
      handleSettle(row) {
        this.$confirm('确认结算该笔款项吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          const param = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            id: row.id
          };

          this.$axios.settlePayment(param).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '结算成功!',
                duration: 2000
              });
              // 刷新数据
              this.DataList();
            } else {
              this.$message.error(res.msg || '结算失败');
            }
          }).catch(error => {
            console.log(error);
            this.$message.error('结算请求失败');
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消结算'
          });
        });
      },

      chooseProxy(id,...params){
        this.searchForm.proxy_id=id;
        this.searchForm.proxy_name=params[0];
      },

      cProxy(){
        this.title2="选择所属代理";
        this.visible2=true;
      },

      closeForm2(){
        this.visible2=false;
      },

      goZcPay(row){
        this.title="支付参数";
        this.visible=true;
        this.formData=row;
        console.log('pay-----',row)
      },

      goPay(row){
        this.$router.push({
          path:'/merchantPayList',
          query:{
            id:row.id
          }
        })
      },

      goMorePay(row){
        this.$router.push({
          path:'/merchantPayMoreList',
          query:{
            id:row.id
          }
        })
      },

      goInfo(row){
        this.$router.push({
          path:'/proxyInfo',
          query:{
            id:row.id
          }
        })
      },

      goEdit(row){
        this.$router.push({
          path:'/posForm',
          query:{
            id:row.id
          }
        })
      },

      goCategory(){
        this.$router.push('/newsCategory')
      },

      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },

      DataList(){
        this.tableLoadData=[];
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          proxy_id:_this.searchForm.proxy_id,
          pageNum:_this.pageNum,
          pageSize:_this.pageSize,
          pay_source_id:7,
          cusid: _this.searchForm.cusid,
          proxy_id_search: _this.searchForm.proxy_id,
          pay_time: _this.searchForm.pay_time,
          is_deal: _this.searchForm.is_deal, // 添加结算状态筛选
        }

        // 清除空值
        Object.keys(param).forEach(key => {
          if (param[key] === '' || param[key] === null || param[key] === undefined) {
            delete param[key];
          }
        });

        this.$axios.findPayIcbcByProxyListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total=res.data.total;

            // 计算统计数据
            this.calculateStatistics(param);
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 计算统计数据
      calculateStatistics(param) {

        this.statistics = {
          totalAmount:0,
          totalCount: 0,
          settledAmount:0,
          settledCount:0
        };

        this.$axios.findStatisticsByProxy(param).then(res=>{
           if(res.code==200){
             this.statistics.totalAmount=res.data['totalBalance'];
             this.statistics.totalCount=res.data['totalCount'];
             this.statistics.settledAmount=res.data['settledBalance'];
             this.statistics.settledCount=res.data['settledCount'];
           }
        })


      },

      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },

      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },

      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.$router.push('/proxyForm')
      },

      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }
          }
        })
      },

      searchSubmit() {
        this.pageNum=1;
        this.DataList();
      },

      // 重置搜索
      resetSearch() {
        const lastMonth = moment().subtract(1, 'months').startOf('month').valueOf();

        this.searchForm = {
          cusid: "",
          service_cusid: "",
          pay_time: lastMonth, // 重置时也设为上个月
          is_deal: "",
          proxy_name: '',
          proxy_id: '',
        };
        this.pageNum = 1;
        this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
    },
  };
</script>

<style scoped>
  /* 全局样式优化 */
  .box-card {
    border: 1px solid #e6ebf5;
  }

  /* 搜索区域美化 */
  .search-container {
    transition: all 0.3s ease;
  }

  .search-container:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  }

  /* 紧凑型统计卡片美化 */
  .compact-stat-card {
    transition: all 0.2s ease;
    cursor: default;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }

  .compact-stat-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-color: #409EFF;
  }

  /* 表格美化 */
  .el-table {
    font-size: 13px;
  }

  .el-table th {
    background-color: #fafafa !important;
    font-weight: 600;
    color: #333;
    height: 50px;
  }

  .el-table tr:hover {
    background-color: #f5f7fa !important;
  }

  /* 表格行样式 */
  .even-row {
    background-color: #fafafa;
  }

  .odd-row {
    background-color: #ffffff;
  }

  /* 按钮样式优化 */
  .el-button--primary {
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
  }

  .el-button--primary:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }

  /* 分页样式优化 */
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }

  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #667eea;
  }

  /* 面包屑导航美化 */
  .el-breadcrumb {
    padding: 10px 0;
    font-size: 14px;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #409EFF;
    font-weight: 500;
  }

  /* 卡片阴影效果 */
  .el-card {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  }

  /* 响应式调整 */
  @media screen and (max-width: 768px) {
    .search-container {
      padding: 15px;
    }

    .compact-stat-card {
      margin-bottom: 15px;
      height: 80px;
    }

    .el-col {
      margin-bottom: 15px;
    }

    .table-header {
      flex-direction: column;
      align-items: flex-start;
    }

    .table-header > div:last-child {
      margin-top: 10px;
    }
  }

  @media screen and (max-width: 576px) {
    .compact-stat-card {
      height: 70px;
      padding: 10px;
    }

    .compact-stat-card div:nth-child(2) {
      font-size: 16px;
    }

    .compact-stat-card div:nth-child(3) {
      font-size: 11px;
    }
  }

  /* 代理选择输入框美化 */
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #606266;
    cursor: pointer;
  }

  .el-input.is-disabled .el-input__inner:hover {
    border-color: #409EFF;
  }

  /* 标签美化 */
  .el-tag {
    border-radius: 12px;
    padding: 0 10px;
    height: 24px;
    line-height: 22px;
  }

  /* 结算状态标签美化 */
  .el-tag--success {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }

  .el-tag--warning {
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }

  /* 结算按钮美化 */
  .settle-btn {
    background: linear-gradient(135deg, #67C23A 0%, #85CE61 100%);
    border: none;
  }

  .settle-btn:hover {
    background: linear-gradient(135deg, #5DAF34 0%, #7AC857 100%);
  }
</style>

<style>
  /* 全局表格样式 */
  .el-table__body tr.current-row > td {
    background-color: #ecf5ff !important;
  }

  .el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
    background-color: #ecf5ff !important;
  }

  /* 表单标签样式 */
  .el-form-item__label {
    color: #606266;
    font-weight: 500;
    padding-right: 10px;
  }

  /* 表格斑马纹样式 */
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #fafafa;
  }

  /* 日期选择器美化 */
  .el-date-editor.el-input {
    width: 100%;
  }

  /* 下拉选项美化 */
  .el-select-dropdown__item {
    padding: 0 20px;
    height: 34px;
    line-height: 34px;
  }

  .el-select-dropdown__item.selected {
    background-color: #f5f7fa;
    color: #409EFF;
  }
</style>
